"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedrawEvents = void 0;
const react_1 = require("react");
const Events_1 = require("./Events");
/**
 * Uses {@link Events} to redraw components on certain events
 *
 * @example
 * // Clicking the button in Foo will redraw Bar
 * // They can be anywhere as long as they share the same RedrawEvents instance
 * const events = new RedrawEvents();
 *
 * const Foo = () => (
 *   // Clicking the button will push a new "test" event
 *   <button onClick={() => events.pushRedrawEvent("test")}>
 *     Click Me!
 *   </button>
 * );
 *
 * const Bar = () => {
 *   // Bar will redraw whenever an event "test" is pushed
 *   events.watchRedrawEvents("test");
 *   return <>{Math.random()}</>;
 * };
 *
 * @class
 * @internal
 */
class RedrawEvents extends Events_1.Events {
    /** Announces a redraw event */
    pushRedrawEvent(eventName) {
        this.publish(eventName);
    }
    /** Forces a component to redraw when a matching event is published */
    watchRedrawEvents(eventName) {
        const [, updateState] = (0, react_1.useState)({});
        const rerender = () => updateState({});
        (0, react_1.useEffect)(() => {
            this.subscribe(eventName, rerender);
            return () => this.unsubscribe(eventName, rerender);
        }, [eventName]);
    }
}
exports.RedrawEvents = RedrawEvents;
